/** DO NOT EDIT -- GENERATED FILE */
/* eslint-disable */
import * as React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import { IGatsbyImageData } from 'gatsby-plugin-image';
import { Image } from '../../Image';

type Data = {
  startingImage: {
    childImageSharp: {
      gatsbyImageData: IGatsbyImageData;
    };
  };
};

export const Flowremind2: React.FC = () => {
  const { startingImage } = useStaticQuery<Data>(
    graphql`
      {
        startingImage: file(relativePath: { eq: "support/workflows/flowremind2.png" }) {
          childImageSharp {
            gatsbyImageData(layout: CONSTRAINED)
          }
        }
      }
    `,
  );
  return (
    <Image image={startingImage.childImageSharp.gatsbyImageData} alt="screenshot" />
  );
};
